import { useEffect, useState } from "react";
import Address from "../../components/Address";
import { Complement } from "../../components/customer_support/Complement";
import { MenuBar } from "../../components/MenuBar";
import { getDetailForCustomer } from "../../services/CustomerAPI";
import "../ContentFrame.css";
import "../Main.css";

export const AnnouncementComplementForm = () => {
    const [complement, setComplement] = useState([]);
    const [id, setId] = useState();
    const [page, setPage] = useState();

    useEffect(() => {
        let splitedPath = window.location.href.split("/");
        let lastPath = splitedPath[splitedPath.length - 1];
        setId(lastPath.split("-")[1]);
        setPage(lastPath.split("-")[0]);
    }, []);

    useEffect(() => {
        id &&
            getDetailForCustomer(id).then((response) => {
                setComplement(response.data);
            });
    }, [id]);

    const goList = () => {
        window.location.href = `/announcement?page=${page}`;
    };

    return (
        <div>
            <MenuBar selected_page={12} />
            <div className="w-full h-full bg-white">
                <div className="common_frame_container">
                    <div className="common_content_container">
                        <div style={{ width: "100%", height: "100px" }}></div>
                        <span className="content_title">자료실</span>
                        <div className="title_line" style={{ width: "121px" }}></div>
                        <Complement complement={complement} goList={goList} id={id} type={"announcement"} />
                        <div style={{ width: "100%", height: "100px" }}></div>
                    </div>
                </div>
            </div>
            <Address />
        </div>
    );
};
